import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { Stack } from '../../models/stack';

@Injectable({
  providedIn: 'root',
})
export class StackService {
  currentDomain = environment.currentApiHostname;
  apiUrl = `https://${this.currentDomain}/api/general`;

  constructor(private http: HttpClient) { }

  get(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
      `/stacks?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  all() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<Stack>>(
      this.apiUrl + `/stacks/index/all`,
      options
    );
  }

  indexByCommodityUuidAndWarehouseUuid(commodityUuid: string, warehouseUuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<Stack>>(
      this.apiUrl + `/stacks/index/by-commodity/${commodityUuid}/by-warehouse/${warehouseUuid}`,
      options
    );
  }

  indexByWarehouse(warehouseUuid: string, paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl + `/stacks/index/by-warehouse/${warehouseUuid}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }


  export(type: string, paginationOptions: PaginationOptions) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/stacks/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Stack>(
      this.apiUrl + `/stacks/${uuid}`,
      options
    );
  }

  store(payload: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<Stack>(
      this.apiUrl + `/stacks`,
      payload,
      options
    );
  }

  update(payload: any, uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<Stack>(
      this.apiUrl + `/stacks/update/${uuid}`,
      payload,
      options
    );
  }
}
